











import flatpickr from "flatpickr";
import { Japanese } from "flatpickr/dist/l10n/ja.js";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import $ from "jquery";
flatpickr.localize(Japanese);
flatpickr.l10ns.default.firstDayOfWeek = 0;
@Component({
  name: "qCalendar",
  components: {},
})
export default class QCalendar extends Vue {
  public datepicker;
  @Prop() public value;
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  public config;
  public mounted(): void {
    this.config.defaultDate = this.value;
    this.config.disableMobile = true;
    this.datepicker = flatpickr($(this.$refs.qcal), this.config);
  }

  public beforeUpdate() {
    this.datepicker.setDate(this.value);
  }

  public destroy() {
    this.datepicker.destroy();
  }

  @Watch("config", { deep: true })
  public changeConfig() {
    for (const configKey of Object.keys(this.config)) {
      this.datepicker.set(configKey, this.config[configKey]);
    }
  }
}
